const isLocalImagePath = (uri: string): boolean =>
  uri === "/tmp" ||
  uri.startsWith("/tmp/") ||
  uri === "/images" ||
  uri.startsWith("/images/");

export function stripQuery(uri: string): string {
  const withoutHash = uri.split("#")[0] || uri;
  const queryIndex = withoutHash.indexOf("?");

  if (queryIndex < 0) {
    return withoutHash;
  }

  const base = withoutHash.slice(0, queryIndex);
  if (isLocalImagePath(base)) {
    return base;
  }

  const query = withoutHash.slice(queryIndex + 1);
  const queryParams = new URLSearchParams(query);
  queryParams.delete("site_id");
  const normalizedQuery = queryParams.toString();

  if (!normalizedQuery) {
    return base;
  }

  return `${base}?${normalizedQuery}`;
}

export function withSiteId(
  uri: string | null | undefined,
  siteId: string
): string | null | undefined {
  if (!uri) return uri;
  const base = stripQuery(uri);
  if (!isLocalImagePath(base)) {
    return base;
  }
  return `${base}?site_id=${siteId}`;
}
